import { createInteriorHero } from './createInteriorHero';

export const FloorPlansHero = createInteriorHero({
  slot: 'FloorPlansHero',
  displayName: 'Floor Plans Hero',
  prefix: 'floorplanshero',
  titleDefault: 'Floor Plans',
  altDefault: 'Floor plans banner',
});

export const AmenitiesHero = createInteriorHero({
  slot: 'AmenitiesHero',
  displayName: 'Amenities Hero',
  prefix: 'amenitieshero',
  titleDefault: 'Amenities',
  altDefault: 'Amenities banner',
});

export const GalleryHero = createInteriorHero({
  slot: 'GalleryHero',
  displayName: 'Gallery Hero',
  prefix: 'galleryhero',
  titleDefault: 'Gallery',
  altDefault: 'Gallery banner',
});

export const NeighborhoodHero = createInteriorHero({
  slot: 'NeighborhoodHero',
  displayName: 'Neighborhood Hero',
  prefix: 'neighborhoodhero',
  titleDefault: 'Neighborhood',
  altDefault: 'Neighborhood banner',
});

export const ContactHero = createInteriorHero({
  slot: 'ContactHero',
  displayName: 'Contact Hero',
  prefix: 'contacthero',
  titleDefault: 'Contact Us',
  altDefault: 'Contact banner',
});

export const VirtualTourHero = createInteriorHero({
  slot: 'VirtualTourHero',
  displayName: 'Virtual Tour Hero',
  prefix: 'virtualtourhero',
  titleDefault: 'Virtual Tour',
  altDefault: 'Virtual tour banner',
});

export const PetPolicyHero = createInteriorHero({
  slot: 'PetPolicyHero',
  displayName: 'Pet Policy Hero',
  prefix: 'petpolicyhero',
  titleDefault: 'Pet Policy',
  altDefault: 'Pet policy banner',
});

export const ScheduleATourHero = createInteriorHero({
  slot: 'ScheduleATourHero',
  displayName: 'Schedule A Tour Hero',
  prefix: 'scheduleatourhero',
  titleDefault: 'Schedule A Tour',
  altDefault: 'Schedule a tour banner',
});

export const InteractiveMapHero = createInteriorHero({
  slot: 'InteractiveMapHero',
  displayName: 'Interactive Map Hero',
  prefix: 'interactivemaphero',
  titleDefault: 'Interactive Map',
  altDefault: 'Interactive map banner',
});

export const PrivacyPolicyHero = createInteriorHero({
  slot: 'PrivacyPolicyHero',
  displayName: 'Privacy Policy Hero',
  prefix: 'privacypolicyhero',
  titleDefault: 'Privacy Policy',
  altDefault: 'Privacy policy banner',
});

export const SitemapHero = createInteriorHero({
  slot: 'SitemapHero',
  displayName: 'Sitemap Hero',
  prefix: 'sitemaphero',
  titleDefault: 'Sitemap',
  altDefault: 'Sitemap banner',
});

export const AccessibilityHero = createInteriorHero({
  slot: 'AccessibilityHero',
  displayName: 'Accessibility Hero',
  prefix: 'accessibilityhero',
  titleDefault: 'Accessibility',
  altDefault: 'Accessibility banner',
});

export const ApplyNowHero = createInteriorHero({
  slot: 'ApplyNowHero',
  displayName: 'Apply Now Hero',
  prefix: 'applynowhero',
  titleDefault: 'Apply Now',
  altDefault: 'Apply now banner',
});

export const ThankYouHero = createInteriorHero({
  slot: 'ThankYouHero',
  displayName: 'Thank You Hero',
  prefix: 'thankyouhero',
  titleDefault: 'Thank You',
  altDefault: 'Thank you banner',
});

export const ReviewsHero = createInteriorHero({
  slot: 'ReviewsHero',
  displayName: 'Reviews Hero',
  prefix: 'reviewshero',
  titleDefault: 'Reviews',
  altDefault: 'Reviews banner',
});

export const ResidentAccessHero = createInteriorHero({
  slot: 'ResidentAccessHero',
  displayName: 'Resident Access Hero',
  prefix: 'residentaccesshero',
  titleDefault: 'Resident Access',
  altDefault: 'Resident access banner',
});
